export default __webpack_public_path__ + "static/media/dia.5985082b.svg";